import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../../../../../../../../components/checkbox';
import { Header } from '../../../../../../../../components/header';
import { useMeterConfigurationContext } from '../../context';
import { useMeterConfigErrorMessage } from '../../hooks/use-error-message';

export const ActionPartForm: React.FC = () => {
  const { t } = useTranslation('channel-details');
  const { activeRuleIndex, form } = useMeterConfigurationContext();
  const { getErrorMessage } = useMeterConfigErrorMessage();

  return (
    <>
      <Header title={t('meterConfiguration.action.actionLabel')} />
      <Controller
        name={`rules.${activeRuleIndex}.isDefaultAction`}
        control={form.control}
        render={({ field, fieldState: { error } }) => {
          const errorMessage = getErrorMessage(activeRuleIndex, 'isDefaultAction', error);

          return (
            <Checkbox checked={field.value} reverse onChange={field.onChange} errorMessage={errorMessage}>
              {t('meterConfiguration.action.defaultAction')}
            </Checkbox>
          );
        }}
      />
      <Controller
        name={`rules.${activeRuleIndex}.isNotifyAction`}
        control={form.control}
        render={({ field, fieldState: { error } }) => {
          const errorMessage = getErrorMessage(activeRuleIndex, 'isNotifyAction', error);

          return (
            <Checkbox checked={field.value} reverse onChange={field.onChange} errorMessage={errorMessage}>
              {t('meterConfiguration.action.notification')}
            </Checkbox>
          );
        }}
      />
    </>
  );
};
